import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const BatchesListPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.BatchesListPage })),
);
const BatchDetailPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.BatchDetailPage })),
);
const EbrDetailPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.EbrDetailPage })),
);
const HoldsListPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.HoldsListPage })),
);
const LossesListPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.LossesListPage })),
);
const HoldDetailPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.HoldDetailPage })),
);
const MesTodayPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesTodayPage })),
);
const MesExecPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesExecPage })),
);
const MesScanPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesScanPage })),
);
const MesCipPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesCipPage })),
);
const MesHandoverPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesHandoverPage })),
);
const MesReworkPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesReworkPage })),
);
const MesUsagePage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.MesUsagePage })),
);
const FieldIpqcPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldIpqcPage })),
);
const FieldFormInstancePage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldFormInstancePage })),
);
const FieldBatchesListPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldBatchesListPage })),
);
const FieldBatchDetailPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldBatchDetailPage })),
);
const MaterialIssuesHubPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.MaterialIssuesHubPage })),
);
const MoMaterialIssuesPage = lazy(() =>
  import("@/modules/planning").then((m) => ({ default: m.MoMaterialIssuesPage })),
);

export const mesOpsRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.MesBatchList, PermissionCodes.MesBatchManage,
                  PermissionCodes.MesHoldList, PermissionCodes.MesHoldManage, PermissionCodes.MesHoldRelease,
                  PermissionCodes.MesLossList,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "mes/batches",
                element: (
                  <LazyPage>
                    <BatchesListPage />
                  </LazyPage>
                ),
              },
              {
                path: "mes/batches/:batchCode",
                element: (
                  <LazyPage>
                    <BatchDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "mes/ebr/:batchCode",
                element: (
                  <LazyPage>
                    <EbrDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "mes/holds",
                element: (
                  <LazyPage>
                    <HoldsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "mes/holds/:holdId",
                element: (
                  <LazyPage>
                    <HoldDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "mes/losses",
                element: (
                  <LazyPage>
                    <LossesListPage />
                  </LazyPage>
                ),
              },
            ],
          },
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.PlnReservationList,
                  PermissionCodes.PlnReservationManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "mes/material-issues",
                element: (
                  <LazyPage>
                    <MaterialIssuesHubPage />
                  </LazyPage>
                ),
              },
              {
                path: "mes/material-issues/:orderNo",
                element: (
                  <LazyPage>
                    <MoMaterialIssuesPage />
                  </LazyPage>
                ),
              },
            ],
          },
];

export const mesFieldRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.MesBatchList, PermissionCodes.MesOperationExecute,
                  PermissionCodes.MesCipList, PermissionCodes.MesCipManage,
                  PermissionCodes.MesHandoffList, PermissionCodes.MesHandoffManage,
                  PermissionCodes.MesReworkList, PermissionCodes.MesReworkManage,
                  PermissionCodes.MesLossList,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "today",
                element: (
                  <LazyPage>
                    <MesTodayPage />
                  </LazyPage>
                ),
              },
              {
                path: "batches",
                element: (
                  <LazyPage>
                    <FieldBatchesListPage />
                  </LazyPage>
                ),
              },
              {
                path: "batches/:batchCode",
                element: (
                  <LazyPage>
                    <FieldBatchDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "scan",
                element: (
                  <LazyPage>
                    <MesScanPage />
                  </LazyPage>
                ),
              },
              {
                path: "cip",
                element: (
                  <LazyPage>
                    <MesCipPage />
                  </LazyPage>
                ),
              },
              {
                path: "handover",
                element: (
                  <LazyPage>
                    <MesHandoverPage />
                  </LazyPage>
                ),
              },
              {
                path: "rework",
                element: (
                  <LazyPage>
                    <MesReworkPage />
                  </LazyPage>
                ),
              },
              {
                path: "usage",
                element: (
                  <LazyPage>
                    <MesUsagePage />
                  </LazyPage>
                ),
              },
              {
                path: "exec/:operationId",
                element: (
                  <LazyPage>
                    <MesExecPage />
                  </LazyPage>
                ),
              },
              {
                path: "ipqc/:operationId",
                element: (
                  <LazyPage>
                    <FieldIpqcPage />
                  </LazyPage>
                ),
              },
              {
                path: "forms/:instanceId",
                element: (
                  <LazyPage>
                    <FieldFormInstancePage />
                  </LazyPage>
                ),
              },
            ],
          },
];
